import { createStore, compose, applyMiddleware } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { reducers } from './ducks/reducers/index.js';
import { rootEpic } from './epics/index.js';

const allowCustomActionObjectsMiddleWare = () => next => (
  action,
) => {
  next({ ...action });
};

const epicMiddleware = createEpicMiddleware();

const enhancer = [];

if (window.__REDUX_DEVTOOLS_EXTENSION__) {
  enhancer.push(window.__REDUX_DEVTOOLS_EXTENSION__());
}

export const store = createStore(
  reducers,
  compose(
    applyMiddleware(allowCustomActionObjectsMiddleWare, epicMiddleware),
    ...enhancer,
  ),
);

epicMiddleware.run(rootEpic);
